import React from "react";
import {Modal, ModalContent, Text, FlexRowCenter, H2} from "@reside/ui";
import {FacilityDropdownTreeSelect} from "../../../../atoms/facility-dropdown-tree-select";
import {SearchResidentsField} from "../SearchResidentsField";
import {useLinkResidentToAdmissionContext} from "../../context/useLinkResidentToAdmissionContext";
import {LinkAnotherResidentRadioForm} from "./LinkAnotherResidentRadioForm";
import {SearchResidentsContextProvider} from "../../context/useFilterResidentsContext";
import {getWorkflowLabel} from "../../../../atoms/start-workflow/workflowMapping";

export const LinkAnotherResidentModal = ({
  onLinked,
}: {
  onLinked: () => void;
}): JSX.Element => {
  const {admission, toggleModal} = useLinkResidentToAdmissionContext();

  return (
    <Modal
      isOpen={!!admission}
      onRequestClose={() => {
        toggleModal();
      }}
      size="large"
      fullScreen
      title={`Link ${getWorkflowLabel(
        admission?.workflowType ?? admission?.workflow_type,
      )}`}
    >
      {({closeModal}) => (
        <ModalContent style={{overflowX: "hidden"}}>
          <SearchResidentsContextProvider>
            <FlexRowCenter
              style={{marginBottom: "20px", justifyContent: "space-between"}}
            >
              <FacilityDropdownTreeSelect />

              <SearchResidentsField />
            </FlexRowCenter>

            <Text style={{marginBottom: "40px"}}>
              Select another resident to link this{" "}
              {getWorkflowLabel(
                admission?.workflowType ?? admission?.workflow_type,
              )}
              . The current resident will be unlinked.
            </Text>
            <LinkAnotherResidentRadioForm
              // @ts-ignore - This is a temporary fix to allow the workflow_type to be used. It will be fixed in https://resideadmissions.atlassian.net/browse/DEV-5827
              workflowType={admission?.workflowType ?? admission?.workflow_type}
              closeModal={closeModal}
              onLinked={onLinked}
            />
          </SearchResidentsContextProvider>
        </ModalContent>
      )}
    </Modal>
  );
};
